import React from "react";
import Main from "../MainLayouts/Main";
import Container from "../GeneralComponents/Container";
import {
  Story,
  Team,
  WhoWeAre,
} from './components';

const About = () => {
  return (
    <Main colorInvert={true}>
      <Container>
        <Story />
      </Container>
      <Container paddingTop={'0 !important'}>
        <WhoWeAre />
      </Container>
      <Container>
        <Team />
      </Container>
    </Main>
  );
};

export default About;
